export const getPageNumber = (page: string): number => Number(page) || 1;
